interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '星辰影院',
      url: 'https://xingchencinema.com',
      logo: 'https://xingchencinema.com/logo.png',
      description: '星辰影院汇集免费电视剧全集，最新热播剧、国产剧高清在线观看，全程不缓冲流畅播放，追剧首选平台。',
      sameAs: [
        'https://weibo.com/xingchencinema',
        'https://space.bilibili.com/xingchencinema',
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@xingchencinema.com',
        availableLanguage: ['Chinese'],
      },
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '星辰影院',
      url: 'https://xingchencinema.com',
      description: '星辰影院：免费电视剧 | 电视剧全集在线观看 - 最新热播剧国产剧高清不缓冲',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://xingchencinema.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}